import AjaxRequest from "./AjaxRequest";
import CallbackHandler from "./CallbackHandler";
import AxiosRequest from "./AxiosRequest";

export default class School {
    constructor() {
        this.output = [];
        this.apiBasePath = "schools/" + localStorage.getItem("school_id");
    }

    async get(url, data = null, func, message) {
        const self = this;
        const callback = new CallbackHandler();
        const api = new AjaxRequest(url, data);

        await api.getRequest().then(function (response) {
            if (response.status == 200) {
                return (self.output = callback.handleSuccess(
                    response,
                    "output"
                ));
            } else {
                callback.handleError(
                    self.constructor.name,
                    func,
                    message,
                    response
                );

                self.output = "An error has occurred, please try again";
            }
        });
    }

    async post(url, data = null, func, message) {
        const self = this;
        const callback = new CallbackHandler();
        const api = new AjaxRequest(url, data);

        await api.postRequest().then(function (response) {
            if (response.status == 200) {
                return (self.output = callback.handleSuccess(
                    response,
                    "output"
                ));
            } else {
                callback.handleError(
                    self.constructor.name,
                    func,
                    message,
                    response
                );

                self.output = "An error has occurred, please try again";
            }
        });
    }

    async patch(url, data = null, func, message) {
        const self = this;
        const callback = new CallbackHandler();
        const api = new AjaxRequest(url, data);

        await api.patchRequest().then(function (response) {
            if (response.status == 200 || response.status == 422) {
                return (self.output = callback.handleSuccess(
                    response,
                    "output"
                ));
            } else {
                callback.handleError(
                    self.constructor.name,
                    func,
                    message,
                    response
                );

                self.output = "An error has occurred, please try again";
            }
        });
    }

    async delete(url, data = null, func, message) {
        const self = this;
        const callback = new CallbackHandler();
        const api = new AjaxRequest(url, data);

        await api.deleteRequest().then(function (response) {
            if (response.status == 200 || response.status == 422) {
                return (self.output = callback.handleSuccess(
                    response,
                    "output"
                ));
            } else {
                callback.handleError(
                    self.constructor.name,
                    func,
                    message,
                    response
                );

                self.output = "An error has occurred, please try again";
            }
        });
    }

    async getSchoolUsers(schnum) {
        return new AxiosRequest().post(`schools/${schnum}/users`, null);
    }

    async getDetails(data) {
        let url = null;
        if (data["id"] || data["schnum"])
            url =
                "schools/" +
                (data["schnum"]
                    ? data["schnum"]
                    : data["id"]
                    ? data["id"]
                    : null);
        else url = this.apiBasePath;

        await this.get(
            url,
            data,
            "getSchoolDetails",
            "Error while retrieving contract details. Please refresh."
        );
        return this.output;
    }

    async contractDetails(contract_id) {
        await this.get(
            this.apiBasePath + "/contracts/" + contract_id,
            null,
            "contractDetails",
            "Error while retrieving contract details. Please refresh."
        );

        return this.output;
    }

    async getContracts(school_id = null) {
        let path;
        if (school_id) {
            path = `schools/${school_id}`;
        } else {
            path = this.apiBasePath;
        }

        await this.get(
            path + "/contracts",
            null,
            "getContracts",
            "Could not fetch contracts. Please try again."
        );
        return this.output;
    }

    async updateContractType(schoolNumber, data) {
        await this.post(
            `schools/${schoolNumber}/contracts/types/manual-update`,
            data,
            "updateContractType",
            "Error updating contract type. Please refresh and try again."
        );

        return this.output;
    }

    async getSchoolYearList(schoolNumber = null)
    {
        let path;
        if (schoolNumber) {
            path = `schools/${schoolNumber}/years`;
        } else {
            path = this.apiBasePath;
        }

        await this.get(
            path,
            null,
            "getSchoolYearList",
            "Could not fetch school year list. Please try again."
        );
        return this.output;
    }

    async getContractsDigitalOnly(school_id = null) {
        let path;
        if (school_id) {
            path = `schools/${school_id}`;
        } else {
            path = this.apiBasePath;
        }

        await this.get(
            path + "/contractsDigital",
            null,
            "getContractsDigitalOnly",
            "Could not fetch contracts. Please try again."
        );
        return this.output;
    }

    async getCountiesAll() {
        await this.get(
            "schools/countiesAll",
            null,
            "schools/getCountiesAll",
            "Could not fetch counties. Please refresh."
        );

        return this.output;
    }

    async getStudents(data) {
        await this.get(
            this.apiBasePath + "/students",
            data,
            "getStudents",
            "Could not fetch students. Please refresh."
        );

        return this.output;
    }

    async getStudentsAll(data) {
        await this.get(
            this.apiBasePath + "/students-all",
            data,
            "getStudents",
            "Could not fetch students. Please refresh."
        );
        return this.output;
    }

    async getTeachers(contract_id) {
        await this.get(
            this.apiBasePath + `/contracts/${contract_id}/teachers`,
            null,
            "getTeachers",
            "Could not fetch teachers. Please refresh."
        );

        return this.output;
    }

    async getGrades(contract_id) {
        await this.get(
            this.apiBasePath + `/contracts/${contract_id}/grades`,
            null,
            "getGrades",
            "Could not fetch grades. Please refresh."
        );

        return this.output;
    }

    async getAllGrades() {
        await this.get(
            "schools/grades",
            null,
            "getAllGrades",
            "Could not fetch all grades. Please refresh."
        );
        return this.output;
    }

    async quickStudentSearch(data) {
        await this.get(
            this.apiBasePath + "/students/quicksearch",
            data,
            "quickStudentSearch",
            "Error while finding students. Please refresh."
        );

        return this.output;
    }

    async searchStudents(
        schoolnum,
        contract_num,
        search_term,
        showImage = null
    ) {
        const data = {
            contract_num: contract_num,
            search_term: search_term,
            show_image: showImage,
        };

        await this.post(
            `schools/${schoolnum}/students/search`,
            data,
            "searchStudents",
            "Error while searching students. Please refresh and try again."
        );

        return this.output;
    }

    async searchSchoolContracts(search) {
        const data = {
            search: search,
        };
        await this.get(
            "schools/searchContracts",
            data,
            "searchSchoolContracts",
            "Could not perform search contracts. Please refresh."
        );
        return this.output;
    }

    async searchSchools(data) {
        await this.get(
            "schools/search",
            data,
            "searchSchools",
            "Could not perform search. Please refresh."
        );

        return this.output;
    }

    async studentStats(data) {
        await this.get(
            "schools/student-stats",
            data,
            "schools/student-stats",
            "Could not get student stats. Please refresh."
        );
        return this.output;
    }

    async getMasterAgreement(data) {
        await this.get(
            "schools/master-agreement",
            data,
            "schools/master-agreement",
            "Could not get school master agreement. Please refresh."
        );
        return this.output;
    }

    async getCurrentYear() {
        await this.get(
            "schools/current-year",
            null,
            "schools/current-year",
            "Could not get current school year. Please refresh."
        );
        return this.output;
    }

    async getNextSchoolYear() {
        await this.get(
            "schools/next-year",
            null,
            "schools/next-year",
            "Could not get next school year. Please refresh."
        );
        return this.output;
    }

    async getSchoolNameAndNumByContract(contract_id) {
        await this.get(
            "schools/getSchoolNameAndNumByContract",
            contract_id,
            "schools/getSchoolNameAndNumByContract",
            "Could not get school name. Please refresh."
        );
        var output = this.output.data[0];
        return output;
    }

    // ---------- ACTIVITY REQUESTS ----------
    async getActivityRequests(data) {
        await this.get(
            `schools/activities`,
            data,
            "schools/activities",
            "Could not get requests. Please refresh and try again."
        );
        return this.output;
    }

    async showActivityRequest(request_id) {
        await this.get(
            `schools/activities/${request_id}`,
            null,
            "schools/activities",
            "Could not get requests. Please refresh and try again."
        );
        return this.output;
    }

    async newActivityRequest(data) {
        await this.post(
            `schools/activities/new`,
            data,
            "newActivityRequest",
            "Could not complete your request. Please refresh and try again."
        );
        return this.output;
    }

    async markActivity(data) {
        await this.patch(
            `schools/activities/${data.activity_id}`,
            data,
            "markActivity",
            "Could not update the activity request. Please refresh and try again."
        );
        return this.output;
    }

    async getSchldiskColumns() {
        await this.get(
            `schools/columns`,
            null,
            "getSchldiskColumns",
            "Could not get columns for matching"
        );
        return this.output;
    }

    async getDatUploadHistory(data) {
        await this.get(
            `schools/${data.school_id}/schooldata`,
            null,
            "getDatUploadHistory",
            "Could not get file history"
        );
        return this.output;
    }

    async uploadData(data) {
        await this.post(
            `schools/${data.school_id}/schooldata`,
            data,
            "uploadData",
            "Could not upload data"
        );
        return this.output;
    }

    async uploadDataFile(data) {
        await this.post(
            `schools/${data.school_id}/schooldata/upload`,
            data,
            "uploadDataFile",
            "Could not upload data file"
        );
        return this.output;
    }

    async deleteDataFile(data) {
        await this.delete(
            `schools/${data.school_id}/schooldata/upload/${data.id}`,
            data,
            "deleteDataFile",
            "Could not delete data file"
        );
        return this.output;
    }

    async getSchoolSummary(schnum) {
        return new AxiosRequest().get(`schools/${schnum}/summary`, null);
    }

    async addLocation(schnum, location) {
        return new AxiosRequest().post(
            `schools/${schnum}/addLocation/${location}`,
            null
        );
    }

    async getSchoolCountByYearReport() {
        return new AxiosRequest().get(
            `schools/getSchoolCountByYearReport`,
            null
        );
    }

    async getTotalSchoolsByRegionSummary() {
        return new AxiosRequest().get(
            `schools/getSchoolCountByYearRegionsReport`,
            null
        );
    }

    async getSchoolContacts(schnum) {
        return new AxiosRequest().get(
            `schools/${schnum}/contacts`,
            null
        );
    }

    async getSchoolContactsForDataRequests(schnum) {
        return new AxiosRequest().get(
            `schools/${schnum}/drcontacts`,
            null
        );
    }

}
